import { render, staticRenderFns } from "./platformRepaymentList.vue?vue&type=template&id=72436fde&scoped=true&"
import script from "./platformRepaymentList.vue?vue&type=script&lang=js&"
export * from "./platformRepaymentList.vue?vue&type=script&lang=js&"
import style0 from "./platformRepaymentList.vue?vue&type=style&index=0&id=72436fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72436fde",
  null
  
)

export default component.exports